import { fetchWithAuth } from '../api';
import { GET_METHOD, HOSTED_APPLICATION_SIMULATION_STATUS_URL } from '../config';

type SimulationStatusResponse = {
  status: string;
  valid_actions: string[];
};

type GetSimulationStatusType = (companyToken: string) => Promise<SimulationStatusResponse | null>;

export const getSimulationStatus: GetSimulationStatusType = async (companyToken) => {
  return await fetchWithAuth<null, SimulationStatusResponse>(
    HOSTED_APPLICATION_SIMULATION_STATUS_URL,
    null,
    companyToken,
    GET_METHOD,
  );
};
